export const css = {
	oneaction: '_3cqVBM1v',
	' _key': 'ascm-theme/ascm/quiz-widgets/questionfeedback'
};

export default css;
